"use strict";
/**
 * Core Feature interfaces, classes, and helpers.
 *
 * @remarks
 * This package is required by every single other Feature Framework package, and includes all
 * common interfaces and abstract classes used down the tree. Take a look at individual classes
 * and interfaces inside this documentation to learn more.
 *
 * @packageDocumentation
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateSecret = exports.BackgroundJobStatus = exports.BoundQueue = exports.QueueService = exports.UploadRequestMode = exports.StorageService = exports.CacheService = exports.SeverityLevel = exports.ErrorService = exports.EmailService = exports.FeatureServicesManager = exports.DEFAULT_APPLICATION_OPTIONS = exports.FeatureRoot = exports.FeatureResourceManager = exports.FeatureHookManager = exports.prefixMutater = exports.removeLogMutater = exports.removeLogListener = exports.LogLevel = exports.addLogMutater = exports.addLogListener = exports.debug = exports.createLog = exports.CLI_HOOK = exports.Feature = void 0;

var Feature_1 = require("./Feature");

Object.defineProperty(exports, "Feature", {
  enumerable: true,
  get: function get() {
    return Feature_1.Feature;
  }
});

var Scriptable_1 = require("./Scriptable");

Object.defineProperty(exports, "CLI_HOOK", {
  enumerable: true,
  get: function get() {
    return Scriptable_1.CLI_HOOK;
  }
});

var log_1 = require("./log");

Object.defineProperty(exports, "createLog", {
  enumerable: true,
  get: function get() {
    return log_1.createLog;
  }
});
Object.defineProperty(exports, "debug", {
  enumerable: true,
  get: function get() {
    return log_1.debug;
  }
});
Object.defineProperty(exports, "addLogListener", {
  enumerable: true,
  get: function get() {
    return log_1.addLogListener;
  }
});
Object.defineProperty(exports, "addLogMutater", {
  enumerable: true,
  get: function get() {
    return log_1.addLogMutater;
  }
});
Object.defineProperty(exports, "LogLevel", {
  enumerable: true,
  get: function get() {
    return log_1.LogLevel;
  }
});
Object.defineProperty(exports, "removeLogListener", {
  enumerable: true,
  get: function get() {
    return log_1.removeLogListener;
  }
});
Object.defineProperty(exports, "removeLogMutater", {
  enumerable: true,
  get: function get() {
    return log_1.removeLogMutater;
  }
});
Object.defineProperty(exports, "prefixMutater", {
  enumerable: true,
  get: function get() {
    return log_1.prefixMutater;
  }
});

var FeatureHookManager_1 = require("./root/FeatureHookManager");

Object.defineProperty(exports, "FeatureHookManager", {
  enumerable: true,
  get: function get() {
    return FeatureHookManager_1.FeatureHookManager;
  }
});

var FeatureResourceManager_1 = require("./root/FeatureResourceManager");

Object.defineProperty(exports, "FeatureResourceManager", {
  enumerable: true,
  get: function get() {
    return FeatureResourceManager_1.FeatureResourceManager;
  }
});

var FeatureRoot_1 = require("./root/FeatureRoot");

Object.defineProperty(exports, "FeatureRoot", {
  enumerable: true,
  get: function get() {
    return FeatureRoot_1.FeatureRoot;
  }
});
Object.defineProperty(exports, "DEFAULT_APPLICATION_OPTIONS", {
  enumerable: true,
  get: function get() {
    return FeatureRoot_1.DEFAULT_APPLICATION_OPTIONS;
  }
});

var FeatureServicesManager_1 = require("./root/FeatureServicesManager");

Object.defineProperty(exports, "FeatureServicesManager", {
  enumerable: true,
  get: function get() {
    return FeatureServicesManager_1.FeatureServicesManager;
  }
});

var EmailService_1 = require("./services/EmailService");

Object.defineProperty(exports, "EmailService", {
  enumerable: true,
  get: function get() {
    return EmailService_1.EmailService;
  }
});

var ErrorService_1 = require("./services/ErrorService");

Object.defineProperty(exports, "ErrorService", {
  enumerable: true,
  get: function get() {
    return ErrorService_1.ErrorService;
  }
});
Object.defineProperty(exports, "SeverityLevel", {
  enumerable: true,
  get: function get() {
    return ErrorService_1.SeverityLevel;
  }
});

var CacheService_1 = require("./services/CacheService");

Object.defineProperty(exports, "CacheService", {
  enumerable: true,
  get: function get() {
    return CacheService_1.CacheService;
  }
});

var StorageService_1 = require("./services/StorageService");

Object.defineProperty(exports, "StorageService", {
  enumerable: true,
  get: function get() {
    return StorageService_1.StorageService;
  }
});
Object.defineProperty(exports, "UploadRequestMode", {
  enumerable: true,
  get: function get() {
    return StorageService_1.UploadRequestMode;
  }
});

var QueueService_1 = require("./services/QueueService");

Object.defineProperty(exports, "QueueService", {
  enumerable: true,
  get: function get() {
    return QueueService_1.QueueService;
  }
});
Object.defineProperty(exports, "BoundQueue", {
  enumerable: true,
  get: function get() {
    return QueueService_1.BoundQueue;
  }
});

var BackgroundJobService_1 = require("./services/BackgroundJobService");

Object.defineProperty(exports, "BackgroundJobStatus", {
  enumerable: true,
  get: function get() {
    return BackgroundJobService_1.BackgroundJobStatus;
  }
});

var secret_1 = require("./secret");

Object.defineProperty(exports, "generateSecret", {
  enumerable: true,
  get: function get() {
    return secret_1.generateSecret;
  }
});

require("./filterNil");